import type { Team } from "@redotech/redo-model/team";
import type { Product } from "../registry/types";

/**
 * Whether the product is already considered "live" for this team via the
 * legacy onboarding flow (or any path that bypasses the setup guide).
 *
 * If true and no progress row exists, the merchant has nothing to set up
 * via the new system — we suppress the widget rather than create a
 * cosmetic backfill row. The dashboard banner still derives from
 * predicates so regressions (e.g. provider disconnect) surface normally.
 *
 * Add a case here when registering a new product.
 */
export function isProductEnabledForTeam(product: Product, team: Team): boolean {
  switch (product) {
    case "disputes":
      return !!team.settings?.disputes?.enabled;
    case "shopperAgent":
      return !!team.settings?.shopperAgent?.enabled;
  }
}
